import EmbeddedVideoPlayer from 'components/VideoPlayer';
import { useViewlogies } from 'context';
import { useEffect } from 'react';
import './videoPlayer.scss';

const VideoPlayer = ({ hidden = false }) => {
    // get data from context
    let {
        streams,
        streamIndex,
        event: { introVideoUrl, memorialMomentsUrl },
        fetchPausedStatus,
    } = useViewlogies();

    const stream = streamIndex === -1 ? undefined : streams[streamIndex];
    const streamId = stream?.id;

    const streamPauseWindowCutoff = stream
        ? new Date(stream?.endTime).setHours(new Date(stream?.endTime).getHours() + 8)
        : 0;

    const insideStreamPauseWindow = new Date() < streamPauseWindowCutoff;

    // Refresh every 30 seconds to check for pausing while stream is scheduled
    useEffect(() => {
        if (insideStreamPauseWindow) {
            const refreshTimerId = setInterval(() => void fetchPausedStatus(), 30000);
            return () => {
                clearInterval(refreshTimerId);
            };
        }
    }, []);

    const videoUrl = streamIndex === -1 ? memorialMomentsUrl : streams[streamIndex].videoUrl;

    // If a stream was left on pause, only show that for up to 8 hours after the scheduled end time
    const streamPaused = stream?.paused && insideStreamPauseWindow;

    return streamPaused ? (
        <div className="player-wrapper stream-paused">This stream is paused until the service resumes.</div>
    ) : (
        <EmbeddedVideoPlayer url={videoUrl} hidden={hidden} introVideoUrl={introVideoUrl} streamId={streamId} />
    );
};

export default VideoPlayer;
